import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ShoppingBag, MessageCircle } from "lucide-react";

export default function NotFound() {
  return (
    <div className="pt-32 pb-20 min-h-screen bg-white flex items-center" data-testid="page-not-found">
      <div className="max-w-2xl mx-auto px-5 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <div className="font-serif-display text-7xl md:text-9xl gold-text leading-none mb-4">404</div>
          <div className="overline mb-3">Lost in the ritual</div>
          <h1 className="font-serif-display text-3xl md:text-5xl tracking-tighter font-light leading-tight">
            We couldn't find that page.
          </h1>
          <p className="text-base text-[#5C5C5C] mt-5 max-w-md mx-auto">
            The link may be outdated or the page might have moved. Try one of the routes below —
            we'll get you back to the good stuff.
          </p>

          <div className="flex items-center justify-center gap-3 mt-9 flex-wrap" data-testid="notfound-actions">
            <Link to="/" className="btn-primary inline-flex" data-testid="notfound-home">
              <Home size={14} /> Take me home
            </Link>
            <Link to="/shop" className="btn-outline inline-flex" data-testid="notfound-shop">
              <ShoppingBag size={14} /> Shop the collection
            </Link>
            <a
              href="https://wa.me/917383899003"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline inline-flex"
              data-testid="notfound-help"
            >
              <MessageCircle size={14} /> WhatsApp help
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
